
import React, { memo, useState } from "react";
import dynamic from "next/dynamic";
import "./index.css";
import { Container } from "react-bootstrap";
import CustomButton from "@/components/common-components/CustomButton";
const CustomModal = dynamic(() => import("@/components/common-components/CustomModal"), { ssr: false });
const BannerSection = () => {
  const [modalShow, setModalShow] = useState(false);
  return (
    <section className="banner">
      <div className="background-banner position-relative d-flex align-items-center">
        <Container className="z-3">
          <div className="grid">
            <div className="g-col-12 g-col-md-7"></div>
            <div className="text-content g-col-12 g-col-md-5">
              <h2 className="text-center text-md-start">
                Customized Care for Every Stage of Your Dental Journey
              </h2>
              <p className="mt-3 lh-lg text-center text-md-start">
                Experience personalized dental care with state-of-the-art
                technology and a warm, compassionate team. From preventive
                cleanings to advanced cosmetic treatments, we’re committed to
                making your smile healthy, confident, and radiant.
              </p>
              <div className="banner-button text-center text-md-start">
                <CustomButton
                  text="Get Appointment"
                  onClick={() => setModalShow(true)}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      {modalShow && <CustomModal show={modalShow} onHide={() => setModalShow(false)} />}
    </section>
  );
};

export default memo(BannerSection);
